import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import { Button } from '@/_components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/_components/ui/form'
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/_components/ui/input-otp'

import type { StepSubmitHandler } from '../_types/step'

const codeStepValidationSchema = z.object({
  code: z
    .string({
      error: 'O código é obrigatório.',
    })
    .trim()
    .length(6, {
      message: 'O código deve ter 6 caracteres.',
    }),
})

type CodeStepValidationSchema = z.infer<typeof codeStepValidationSchema>

export type CodeStepSubmitHandler = StepSubmitHandler<CodeStepValidationSchema>

interface CodeStepProps {
  onSubmit: CodeStepSubmitHandler
}

export const CodeStep = ({ onSubmit }: CodeStepProps) => {
  const form = useForm<CodeStepValidationSchema>({
    resolver: zodResolver(codeStepValidationSchema),
  })

  return (
    <Form {...form}>
      <form
        className="space-y-6"
        onSubmit={form.handleSubmit((data) => onSubmit(data, form.setError))}
      >
        <FormField
          control={form.control}
          name="code"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Insira o código</FormLabel>
              <FormControl>
                <InputOTP maxLength={6} {...field}>
                  <InputOTPGroup>
                    <InputOTPSlot index={0} />
                    <InputOTPSlot index={1} />
                    <InputOTPSlot index={2} />
                    <InputOTPSlot index={3} />
                    <InputOTPSlot index={4} />
                    <InputOTPSlot index={5} />
                  </InputOTPGroup>
                </InputOTP>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button type="submit" className="w-full" disabled={form.formState.isSubmitting}>
          Criar senha
        </Button>
      </form>
    </Form>
  )
}
